import {useNavigate, useParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {exibirMensagemErro, formatarDinheiro, formatarDinheiroParaDecimal, HttpVerbo, xfetch} from "../../util";
import {Card} from "../../componentes/card/Card";
import {Botao, BotaoFechar, BotaoSalvar, PaginaLogada, SelectFetch} from "../../componentes";
import {Modal} from "react-bootstrap";

export default function NovaMeta() {

  const navegacao = useNavigate()
  const parametros = useParams()
  const [isAberto, setIsAberto] = useState(false)
  const [projeto, setProjeto] = useState({
    nome: '...'
  })

  const [modalNovoItem, setModalNovoItem] = useState(false)
  const fecharModalNovoItem = () => setModalNovoItem(false);
  const abrirModalNovoItem = () => setModalNovoItem(true);

  const [isCarregando, setIsCarregando] = useState(false)
  const [itens, setItens] = useState([])
  const [item, setItem] = useState({
    nome: '',
    quantidade: '',
    convenente: '',
    valorCotado: '',
    valorExecutado: '',
    numeroEdoc: '',
    naturezaDespesa: '',
    forca: -1,
  })
  const [meta, setMeta] = useState({
    descricao: '',
    valorEstimado: '',
    valorEstimadoCusteio: '',
    valorEstimadoCapital: '',
    contaCusteio: -1,
    contaCapital: -1,
    forca: -1,
    itens: []
  })

  function carregarProjeto() {
    setIsCarregando(true)
    const id = parametros.id
    xfetch('/projeto/' + id, {}, HttpVerbo.GET)
      .then(res => res.json())
      .then(data => {
        setProjeto(data)
        setIsCarregando(false)
      })
      .catch(err => {
        setIsCarregando(false)
        exibirMensagemErro("Erro ao carregar projeto - " + err.messsage)
      })

  }

  useEffect(() => {
    carregarProjeto()
  }, [])


  function removeMascara(valor) {
    return valor.replaceAll('.', '').replaceAll(',', '.')
  }

  function cadastrarMeta() {

    setIsCarregando(true)

    const arr = itens.map(i => {
      i.valorCotado = removeMascara(i.valorCotado)
      i.valorExecutado = removeMascara(i.valorExecutado)
      return i
    })
    const dados = {
      descricao: meta.descricao,
      valorEstimado: removeMascara(meta.valorEstimado),
      forcaId: meta.forca,
      naturezaDespesaId: meta.naturezaDespesa,
      numeroEdoc: meta.numeroEdoc,
      itens: arr,
      valorEstimadoCusteio: removeMascara(meta.valorEstimadoCusteio),
      valorEstimadoCapital: removeMascara(meta.valorEstimadoCapital),
      contaCusteio: meta.contaCusteio,
      contaCapital: meta.contaCapital,
    }


    const endpoint = '/projeto/'+projeto.id + '/metas'

    xfetch(endpoint, dados, HttpVerbo.POST)
      .then(res => res.json())
      .then(data => {
        //TODO listagem
        navegacao('/projeto/'+ projeto.id, {replace: true})
      })
      .catch(err => exibirMensagemErro("Erro ao cadastrar meta - " + err.message) & setIsCarregando(false))
  }


  function isFundoAFundo() {
    return projeto.fonteRecurso == 'FUNDO A FUNDO';
  }

  let descricaoCard = isFundoAFundo()
    ? "Novo eixo para - "
    : "Nova meta para - "

  const NovoItem = () => {
    return (
      <div className="row text-lg-end mb-3">
        <div className="col-12 align-right">
          <Botao icone={"bi bi-bag-plus"} onClick={abrirModalNovoItem} data-bs-toggle="modal" data-bs-target="#mSetor">
            Adicionar Item
          </Botao>
        </div>
      </div>);
  }

  let tituloPagina = isFundoAFundo()
    ? "Criar eixo"
    : "Criar meta"

  return (
    <PaginaLogada isCarregando={isCarregando} titulo={tituloPagina} botaoVoltar>
        <Card className="pb-5" titulo={descricaoCard + projeto.nome}>
          <div className="row mb-5">
            <div className="col-lg-6">
              <label> Descrição: </label>
              <input
                type="text"
                value={meta.descricao}
                name='descricao'
                autoComplete="off"
                className="form-control"
                placeholder={isFundoAFundo() ? "Descrição do eixo" : "Descrição da meta"}
                onChange={(e) => setMeta({...meta, [e.target.name]: e.target.value.toString().toUpperCase()})}/>
            </div>

            <div className={ isFundoAFundo() ? "d-none" : "col-lg-2"}>
              <label> Valor estimado: </label>
              <input type="text" className="form-control"
                 aria-label="Valor total"
                 autoComplete="off"
                 value={"R$ "+formatarDinheiro(meta.valorEstimado)}
                 onChange={(e) => setMeta({...meta, valorEstimado: formatarDinheiro(e.target.value)})}/>
            </div>
            <div className={ isFundoAFundo() ? "d-none" : "col-lg-3"}>
              <label>Força:</label>
              <SelectFetch
                setIsCarregando={setIsCarregando}
                handleChange={(e) => setMeta({...meta, forca: e.value})}
                url='/forca' placeholder='Selecione a força'/>
            </div>
          </div>
          <div className={ isFundoAFundo() ? "row" : "d-none"}>

            <div className={ isFundoAFundo() ? "col-lg-3" : "d-none"}>
              <label> Valor estimado custeio: </label>
              <input type="text" className="form-control"
                     aria-label="Valor custeio"
                     autoComplete="off"
                     value={"R$ "+formatarDinheiro(meta.valorEstimadoCusteio)}
                     onChange={(e) => setMeta({...meta, valorEstimadoCusteio: formatarDinheiro(e.target.value)})}/>
            </div>
            <div className={ isFundoAFundo() ? "col-lg-3" : "d-none"}>
              <label> Conta de custeio: </label>
              <SelectFetch setIsCarregando={setIsCarregando}
                 handleChange={(e) => setMeta({...meta, contaCusteio: e.value})} url='/conta/select'
                 placeholder='Selecione a conta'/>
            </div>
            <div className={ isFundoAFundo() ? "col-lg-3" : "d-none"}>
              <label> Valor estimado capital: </label>
              <input type="text" className="form-control"
                     aria-label="Valor capital"
                     autoComplete="off"
                     value={"R$ "+formatarDinheiro(meta.valorEstimadoCapital)}
                     onChange={(e) => setMeta({...meta, valorEstimadoCapital: formatarDinheiro(e.target.value)})}/>
            </div>
            <div className={ isFundoAFundo() ? "col-lg-3" : "d-none"}>
              <label> Conta de capital: </label>
              <SelectFetch setIsCarregando={setIsCarregando}
                 handleChange={(e) => setMeta({...meta, contaCapital: e.value})} url='/conta/select'
                 placeholder='Selecione a conta'/>
            </div>
          </div>

          <div className="row mt-3 d-flex justify-content-center">
            <div className="col-lg-3 text-center d-grid gap-2">
              <BotaoSalvar onClick={cadastrarMeta} />
            </div>
          </div>

          <div className={"row mt-3 " + isFundoAFundo() ? "d-none" : ""}>
            <NovoItem abrirModal={() => {setModalNovoItem(true)}}/>

            <div className="col-lg-12 bordered">
              <table className="table text-center">
                <thead>
                <tr>
                  <th>Nome</th>
                  <th>Quantidade</th>
                  <th>Valor Cotado</th>
                  <th>Valor Executado</th>
                  <th>Ação</th>
                </tr>
                </thead>
                <tbody>
                {itens.map((v, k) => {
                  return (
                    <tr key={k}>
                      <td>{v.nome}</td>
                      <td>{v.quantidade}</td>
                      <td>R$ {v.valorCotado}</td>
                      <td>R$ {v.valorExecutado}</td>
                      <td>
                        <span onClick={() => itens.splice(k, 1) & setItens([...itens]) }>
                        <i className="bi bi-trash text-danger"/>
                        </span>
                      </td>
                    </tr>
                  );
                })}
                </tbody>
              </table>
            </div>
          </div>

        </Card>
        <Modal show={modalNovoItem} onHide={fecharModalNovoItem} backdrop="static" size="lg">
          <Modal.Header closeButton>
            <Modal.Title>
              Novo Item
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="col-lg-12 mb-2">
              <input
                className="form-control" type="text"
                name="nome"
                autoComplete="off"
                placeholder="Nome item" value={item.nome}
                onChange={(e) => setItem({...item, nome: e.target.value.toString().toUpperCase()})}/>
              <div className="col-lg-12 mb-2">
                <input
                  className="form-control" type="number"
                  name="quantidade"
                  placeholder="Quantidade" value={item.quantidade}
                  onChange={(e) => setItem({...item, quantidade: parseInt(e.target.value)})}/>
              </div>

              <div className={"col-lg-12 mb-2 " + isFundoAFundo() ? "d-none" : ""}>
                {/*<label> Número E-DOC: </label>*/}
                <input
                  type="text"
                  value={item.numeroEdoc}
                  name='numeroEdoc'
                  autoComplete="off"
                  className="form-control"
                  placeholder="Número E-DOC"
                  onChange={(e) => setItem({...item, numeroEdoc: e.target.value.toString().toUpperCase()})}/>
              </div>

              <div className={"col-lg-12 mb-2 " + isFundoAFundo() ? "d-none" : ""}>
                {/*<label>Natureza Despesa:</label>*/}
                <SelectFetch
                  setIsCarregando={setIsCarregando}
                  handleChange={(e) => setItem({...item, naturezaDespesa: e.value})}
                  url='/naturezaDespesa' placeholder='Selecione a natureza'/>
              </div>

              <div className={"col-lg-12 mb-2 " + isFundoAFundo() ? "d-none" : ""}>
                <SelectFetch url='/convenente' handleChange={(v) => setItem({...item, idConvenente: v.value})}
                             placeholder="Convenente" setIsCarregando={setIsCarregando}/>
              </div>

              <div className={ isFundoAFundo() ? "col-lg-12" : "d-none"}>
                <SelectFetch
                  setIsCarregando={setIsCarregando}
                  handleChange={(e) => setItem({...item, forca: e.value})}
                  url='/forca' placeholder='Selecione a força'/>
              </div>

              <div className="col-lg-12 mb-2">
                <input
                  className="form-control" type="text"
                  placeholder="Valor Cotado" value={formatarDinheiro(item.valorCotado)}
                  onChange={(e) => setItem({...item, valorCotado: formatarDinheiroParaDecimal(e.target.value)})}/>
              </div>

              <div className="col-lg-12">
                <input
                  className="form-control" type="text"
                  placeholder="Valor unitário executado" value={formatarDinheiro(item.valorExecutado)}
                  onChange={(e) => setItem({...item, valorExecutado: formatarDinheiroParaDecimal(e.target.value)})}/>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <BotaoSalvar margem={1} onClick={armazenarItem}/>
            <BotaoFechar onClick={fecharModalNovoItem} data-bs-dismiss="modal"/>
          </Modal.Footer>
        </Modal>


    </PaginaLogada>
  )

  function validaItem() {
    if (item.nome === '') {
      exibirMensagemErro("Preencha o nome do item")
      return false
    }

    if (item.quantidade === '' || item.quantidade === 0) {
      exibirMensagemErro("Preencha a quantidade do item")
      return false
    }

    if (item.valorCotado === '' || item.valorCotado === 0) {
      exibirMensagemErro("Preencha o valor cotado")
      return false
    }

    if (!isFundoAFundo() && (item.naturezaDespesa === '' || item.naturezaDespesa === 0)) {
      exibirMensagemErro("Preencha a natureza da despesa")
      return false
    }

    return true
  }

  function limparItem() {
    setItem({
      nome: '',
      quantidade: '',
      valorCotado: '',
      valorExecutado: '',
      numeroEdoc: '',
    })
  }

  function armazenarItem(e) {
    e.preventDefault()
    if (!validaItem()) {
      return
    }
    setItens([...itens, item])
    localStorage.setItem("itens", JSON.stringify(itens))
    limparItem();
    setIsAberto(false)
  }
}

